$component-class: 'me-list';

.#{$component-class} {
  margin: 0;
  padding: 0;
  list-style: none;

  &--column {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-sm);
  }

  &--inline {
    display: flex;
    flex-flow: row wrap;
    gap: var(--spacing-md);
    align-items: center;
  }

  &--numbered {
    counter-reset: list-counter;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: var(--spacing-xs);

    .#{$component-class}--numbered & {
      counter-increment: list-counter;
    }
  }

  &__icon {
    flex-shrink: 0;

    @include size(map-get($font-sizes, 2xl));

    color: var(--color-brand-primary-main);
  }

  &__number {
    flex-shrink: 0;
    color: var(--color-brand-primary-main);
  }

  &__text {
    flex: 1;
  }

  &--inline &__item {
    flex-shrink: 0;
  }

  &--inline &__text {
    flex: none;
  }
}
